/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteDecisionRequest
 */
export interface QuoteDecisionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuoteDecisionRequest
     */
    applicationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteDecisionRequest
     */
    accept?: boolean;
}

/**
 * Check if a given object implements the QuoteDecisionRequest interface.
 */
export function instanceOfQuoteDecisionRequest(value: object): value is QuoteDecisionRequest {
    return true;
}

export function QuoteDecisionRequestFromJSON(json: any): QuoteDecisionRequest {
    return QuoteDecisionRequestFromJSONTyped(json, false);
}

export function QuoteDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteDecisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
        'accept': json['accept'] == null ? undefined : json['accept'],
    };
}

export function QuoteDecisionRequestToJSON(json: any): QuoteDecisionRequest {
    return QuoteDecisionRequestToJSONTyped(json, false);
}

export function QuoteDecisionRequestToJSONTyped(value?: QuoteDecisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'accept': value['accept'],
    };
}

